import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomNotificationModal = ({ isModalOpen, modal }) => {
  const {
    icon,
    header,
    onSubmitClick,
    btnTextPrimary,
    size = "smd",
    color = "black",
    iconSize = "3x",
    btnColor,
  } = modal;

  return (
    <Modal show={isModalOpen} size={size}>
      <Modal.Body>
        <div className="d-flex">
          <div className="pd-15">
            <FontAwesomeIcon
              icon={icon}
              size={iconSize}
              className="mt-3 primary-color"
            />
          </div>
          <div className="remove-text">
            <h4>{header}</h4>
            <br />
            <Button
              className="ml-5"
              variant="primary"
              onClick={() => onSubmitClick()}
            >
              {btnTextPrimary}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomNotificationModal;
